import { PaySetting, PaySettingFormData } from "../types/paySetting";
import { get, post } from "./fetch.core";

async function addPaySetting(data: PaySettingFormData) {
  sanitizePaySetting(data);
  await post("/admin/paySetting/add", data);
}

function sanitizePaySetting(data: Partial<PaySettingFormData>) {
  if (!data.countryIds) delete data.countryIds;
  if (!data.shipTypes) delete data.shipTypes;
}

async function list() {
  const res = await get<PaySetting[]>("/admin/paySetting/list");
  return res.data;
}

async function single(id: string) {
  const res = await get<PaySetting>(`/admin/paySetting/single?id=${id}`);
  return res.data;
}

async function updatePaySetting(id: string, data: PaySettingFormData) {
  sanitizePaySetting(data);
  await post("/admin/paySetting/update", { id, ...data });
}

async function deletePaymentSetting(id: string) {
  await post("/admin/paySetting/delete", { id });
}

function covertPaySettingToFormData(paySetting: PaySetting): PaySettingFormData {
  return {
    payType: paySetting.payType,
    name: paySetting.name,
    shipTypes: paySetting.shipTypes,
    countryIds: paySetting.countryList.map((c) => c.id),
    setting: paySetting.setting,
  };
}

const obj = {
  addPaySetting,
  single,
  updatePaySetting,
  deletePaymentSetting,
  list,
  covertPaySettingToFormData,
};

export default obj;
